module.exports = __webpack_public_path__ + "img/2.c38b88e1.jpg";